<template>
  <b-container>
    <b-form @submit.prevent="onSubmit">
      <h5>{{ title }}</h5>
      <name-and-link-manager :label="'عنوان'"
                             :router-link="{ name: 'SingleCourse', params: { slug: form.titleAndSlug.link } }"
                             v-model="form.titleAndSlug" :validation="$v.form.titleAndSlug.name">
        <published-checkbox label="وضعیت انتشار" v-model="form.status"/>
      </name-and-link-manager>

      <b-row class="my-5 "> عکس</b-row>
      <b-row>
        <b-col sm="3" md="3">
          <single-image v-model="form.thumbnail" :mainPreview="form.mainPreview"
                        :validation="$v.form.thumbnail"></single-image>
        </b-col>

      </b-row>


      <b-row class="my-5">
        <b-col lg="4">
          <label>کد دوره در spot player</label>
          <b-form-input v-model="form.spot_player_course_id"></b-form-input>
        </b-col>
      </b-row>

      <b-row class=" my-5">
        <published-checkbox label="آیا دوره پایان یافته است؟" v-model="form.course_status"/>

        <form-group :validations="$v.form.description" class="w-100">
          <div slot-scope="{ errors, invalid }">
            <label>توضیحات وضعیت دوره</label>
            <div class="form-group">
              <vue2-tinymce-editor v-model="form.description" :options="defaultToolbar"></vue2-tinymce-editor>
            </div>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

      </b-row>

      <b-row>

        <b-col md="6">
          <form-group :validations="$v.form.courseProducts">
            <div slot-scope="{ errors, invalid }">
              <b-alert show class="overflow_div">
                <b-form-group>
                  <label>
                    <b> محصولات متصل شده به دوره</b>
                  </label>
                  <div class="items">
                    <span class="d-block mt-1 cursor_pointer"
                          v-for="(item,index) in form.courseProducts"
                          @click="removeProductOfCourse(item)"
                          :key="index">{{ item.product.name }}</span>
                  </div>
                </b-form-group>
              </b-alert>
              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>
        </b-col>

        <b-col md="6">
          <b-alert show class="overflow_div">
            <b-form-group>
              <label>
                <b>محصولات</b>
              </label>
              <b-form-input
                  v-model="searchOnProduct"
                  style="position:sticky;top:0"
                  @keyup.enter.prevent="searchProducts"
                  placeholder="جست و جو در محصولات"/>
              <div class="items">

                <div v-for="(product,index) in products" :key="index">
                  <p class="mt-1 cursor_pointer"
                     v-for="(sub_product,index) in subProducts(product)" :key="index*2"
                     @click="addProductToCourse(sub_product)">
                    {{ sub_product.name }}
                  </p>
                </div>


              </div>
            </b-form-group>
          </b-alert>
        </b-col>

        <languageBox v-model="form.language_id" :validation="$v.form.language_id"/>


      </b-row>


      <b-row class="mt-5">
        <form-group :validations="$v.form.abstract" class="w-100">
          <div slot-scope="{ errors, invalid }">
            <label>چکیده</label>
            <div class="form-group">
              <vue2-tinymce-editor v-model="form.abstract" :options="defaultToolbar"></vue2-tinymce-editor>
            </div>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>
      </b-row>

      <b-row class="mt-5">
        <form-group :validations="$v.form.body" class="w-100">
          <div slot-scope="{ errors, invalid }">
            <label>متن</label>
            <b-row>
              <b-col lg="6">
                <add-iframe-to-editor @iframe-handler="iframeHandlerFunction"/>
              </b-col>
            </b-row>
            <div class="form-group">
              <vue2-tinymce-editor v-model="form.body" :options="defaultToolbar"></vue2-tinymce-editor>
            </div>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>
      </b-row>

      <b-row class="my-5">
        <b-col md="8" class="m-auto">
          <b-button pill type="submit" variant="purple" class="w-100"
          >تایید
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>
<script>
import router from '@/router';
import {mapGetters} from "vuex";
import category from "../product/category.vue";
import {required, numeric} from "vuelidate/lib/validators";
import FormGroup from "../../validator/FormGroup.vue";
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import NameAndLinkManager from "../Content/FormItems/NameAndLinkManager.vue";
import PublishedCheckbox from "../Content/FormItems/PublishedCheckbox.vue";
import SingleImage from "../Content/FormItems/SingleImage.vue";
import RadioBox from "../Content/FormItems/RadioBox.vue";
import CheckBoxManager from "../Content/FormItems/CheckBoxManager.vue";
import FormInput from "../Content/FormItems/FormInput.vue";
import FormTextArea from "../Content/FormItems/FormTextArea.vue";
import KeyWordsManager from "../Content/FormItems/KeyWordsManager.vue";
import {defaultToolbar} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/EditorToolbarSetting'
import {subProducts} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import languageBox from "../Language/LanguageBox";
import AddIframeToEditor from "../Content/FormItems/AddIframeToEditor";
import {Vue2TinymceEditor} from "vue2-tinymce-editor";


export default {
  name: "CreateContentLayout",
  components: {
    category,
    FormGroup,
    FormErrorsManager,
    NameAndLinkManager,
    PublishedCheckbox,
    SingleImage,
    RadioBox,
    CheckBoxManager,
    FormInput,
    FormTextArea,
    KeyWordsManager,
    languageBox,
    AddIframeToEditor,
    Vue2TinymceEditor,
  },
  props: ["title", "submitFunction"],
  data() {
    return {
      form: {
        id: '',
        titleAndSlug: {name: "", link: ""},
        thumbnail: [],
        description: "",
        course_status: null,
        status: false,
        abstract: "",
        body: "",
        mainPreview: "",
        courseProducts: [],
        language_id: '',
        spot_player_course_id: null
      },
      searchOnProduct: '',
      defaultToolbar
    };
  },
  validations: {
    form: {
      titleAndSlug: {name: {required}},
      abstract: {required},
      description: {},
      body: {required},
      language_id: {required},
      thumbnail: {
        required: (value) => {
          return router.currentRoute.params.slug != undefined || value.length !== 0;
        }
      },
      courseProducts: {required},
      spot_player_course_id: {},
    },
  },
  computed: {
    ...mapGetters({
      categories: "Category/getCategories",
      products: "Course/getProducts",
    }),
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.invalid()) {
        const form = {title: this.form.titleAndSlug.name, slug: this.form.titleAndSlug.link, ...this.form};
        console.log(form)
        this.submitFunction(form);
      }
    },
    iframeHandlerFunction(iframe) {
      this.form.body += iframe;
    },
    addProductToCourse(product) {
      if (!this.form.courseProducts.find(item => item.sub_product_id === product.sub_product_id && item.product_id === product.id)) {
        this.form.courseProducts.push({
          product_id: product.id,
          sub_product_id: product.sub_product_id,
          product: product
        });
      }
    },
    removeProductOfCourse(product) {
      if (confirm('آیا مطمئن هستید؟')) {
        this.form.courseProducts.splice(this.form.courseProducts.indexOf(product), 1);
      }
    },
    searchProducts() {
      let searchText = this.searchOnProduct;
      this.$store.dispatch('Course/dashboardSearchForDigitalProduct', searchText);
    },
    subProducts,
    imageHandlerFunction(image) {
      this.form.body += image;
    },
    videoHandlerFunction(video) {
      this.form.body += video;
    },
  },
  async mounted() {
    await this.$store.dispatch("Course/getProducts");
    const routerslug = this.$route.params.slug;
    if (routerslug !== undefined) {
      this.$store.dispatch("Course/getDashboardCourse", routerslug).then(async (res) => {

        this.form.id = res.id;
        this.form.titleAndSlug.name = res.title;
        this.form.titleAndSlug.link = res.slug;
        this.form.status = res.status ? true : false;
        this.form.mainPreview = res.thumbnail;
        this.form.spot_player_course_id = res.spot_player_course_id;

        this.form.course_status = res.course_status.course_status
        this.form.description = res.course_status.description;

        this.form.abstract = res.abstract
        this.form.body = res.body

        res.products.forEach(product => {

          const product_pivot = product.product_pivot

          subProducts(product).forEach(subProduct => {
            if (subProduct.sub_product_id == product_pivot.sub_product_id) {
              console.log(subProduct);
              this.addProductToCourse(subProduct);
            }
          });


        });

        let language_id = await res.language_id;
        document.getElementById(`language_item_${language_id}`).click();


      });
    }
  },
};
</script>
<style scoped>
.direction {
  direction: rtl;
}

.overflow_div {
  width: auto;
  height: 300px !important;
  overflow-y: auto;
}

.cursor_pointer {
  cursor: pointer;
}

</style>